/**
 * Render a month label with its trailing calendar-year suffix ("'25") in a small
 * grey font. The suffix is produced by formatMonthLabel (e.g. "FY26 Nov'25").
 *
 * Labels without a trailing 'YY (e.g. product / status names, or pure quarter
 * labels like "FY26 Q1") render unchanged, so this is safe to use inside generic
 * dropdowns that also list non-month options.
 */
export function MonthLabel({ value, className }: { value: string; className?: string }) {
  const match = value.match(/^(.*)('\d{2})$/);
  if (!match) return <span className={className}>{value}</span>;
  return (
    <span className={className}>
      {match[1]}
      <span className="opacity-60 text-[0.85em]">{match[2]}</span>
    </span>
  );
}
